import enquire from 'enquire.js';
import PubSub from 'pubsub-js';
import { PageEvents } from './page';
import { Responsive } from '../utils';
import { TextColorCheck } from '../utils/textColorCheck';

import './double-col.scss';

const COMPONENT_NAME = 'double-col';
const BEM = {
  BLOCK: COMPONENT_NAME,
};

/**
 * version    1.0
 * class      <type> (DoubleCol)
 */
export class DoubleCol {
  constructor() {
    const self = this;

    this._els = {
      doubleCol: $(`.${BEM.BLOCK}`),
    };

    // init UI
    PubSub.subscribe(PageEvents.PAGE_READY, () => {
      self._els.doubleCol.each(function () {
        const $instanceEl = $(this);
        self.initRelocate($instanceEl);
        TextColorCheck._checkBackground($instanceEl);
      });
    });
  }

  initRelocate($instanceEl) {
    const $elToMove = $instanceEl.find('.double-col__right').parent();

    // controllo che ci sia il data-mobile-position e che non sia vuoto
    if ($elToMove.children().data('mobile-position') && $elToMove.children().data('mobile-position').length > 0) {
      const placeToMove = $elToMove.children().data('mobile-position');

      enquire.register(`${Responsive.getBreakpointMaxMediaQuery('sm')}`, () => {
        switch (placeToMove) {
          case 'before-text':
            $elToMove.relocate('before', $instanceEl.find('.double-col__left').parent());
            break;

          case 'after-text':
            $elToMove.relocate('after', $instanceEl.find('.double-col__left').parent());
            break;

          default:
            throw new Error('\ndata-mobile-position error');
        }
      });

      enquire.register(`${Responsive.getBreakpointMinMediaQuery('md')}`, () => {
        $elToMove.relocate('origin');
      });
    }
  }
}
